export type FunnelIntent = 'buy_ticket' | 'create_event'

export type AnalyticsEventName =
  | 'buy_ticket_event_listing'
  | 'buy_ticket_login'
  | 'buy_ticket_event_detail'
  | 'buy_ticket_registration_complete'
  | 'create_event_login'
  | 'create_event_dashboard'
  | 'create_event_step_1'
  | 'create_event_step_2'
  | 'create_event_step_3'
  | 'create_event_published'

export const parseFunnelIntent = (
  value: string | string[] | undefined
): FunnelIntent | undefined => {
  const intent = Array.isArray(value) ? value[0] : value
  return intent === 'buy_ticket' || intent === 'create_event'
    ? intent
    : undefined
}

export const getFunnelLoginEvent = (
  intent: FunnelIntent | undefined
): AnalyticsEventName | undefined => {
  if (intent === 'buy_ticket') return 'buy_ticket_login'
  return 'create_event_login'
}

export const pushDataLayerEvent = (eventName: AnalyticsEventName): void => {
  console.log({ triggeredEvent: eventName })
  if (typeof window === 'undefined') return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: eventName,
  })
  console.log({ dataLayer: window.dataLayer })
}

export const pushFunnelLoginEvent = (
  intent: FunnelIntent | undefined
): void => {
  const eventName = getFunnelLoginEvent(intent)
  if (eventName) pushDataLayerEvent(eventName)
}

export default pushDataLayerEvent
